import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../../theme';

export default StyleSheet.create({
  text: {
    fontFamily: textStyles.regular,
    fontSize: 10,
    color: colorPalette.grey6,
    marginBottom: 4,
    textAlign: 'center',
  },
  pointsWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  point: {
    height: 8,
    width: 8,
    borderRadius: 8,
  },
});
